import { createClient } from '@supabase/supabase-js';

// Go to Supabase Dashboard -> Settings -> API to get these
const supabaseUrl = 'https://bekumfinaxcdrsveeqde.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJla3VtZmluYXhjZHJzdmVlcWRlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAzMTI3MjEsImV4cCI6MjA4NTg4ODcyMX0.hwfS3p9W32rr0iYHEQYsDZvtHj4AFfS27FYMyux3Vbw'; // The "public" key, NOT the service_role one

export const supabase = createClient(supabaseUrl, supabaseKey);